<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

<ngf-dialog-title mat-dialog-title>
  {{title}}
</ngf-dialog-title>

<div mat-dialog-content>
  <span [innerHTML]="text"></span>
  @if (warningText) {
    <span>
      <ngf-message-warning>
        {{warningText}}
      </ngf-message-warning>
    </span>
  }
</div>

<div mat-dialog-actions>
  <ngf-button-group>
    <button ngfButton mat-dialog-close>
      <span>{{ cancelLabel || 'Cancel' }}</span>
    </button>
    <button class="delete" type="submit" ngfButton="primary" (click)="handleSubmit()">
      <span>
        <mat-icon>delete</mat-icon>
        <span>{{ deleteLabel || 'Delete' }}</span>
      </span>
    </button>
  </ngf-button-group>
</div>
